export class HeaderModel {
    courseName: string = '';
    userName: string = '';
    lessonName: string = '';
}


